import { Routes } from '@/router/routes'

import { AppPermissions } from '@/types/enums/permissions/permissions'
import { Middleware } from '@/types/enums/middleware/middleware'

import type { RouteLocation } from 'vue-router'

const routeToVehicleRoute = (routeName: string) => (to: RouteLocation) => ({
  name: routeName,
  params: {
    vehicleId: to.params.vehicleId,
  },
})

const routeToMaintenanceTicket = (to: RouteLocation) => ({
  name: Routes.VehicleManagementViewMaintenanceTicket,
  params: {
    vehicleId: to.params.vehicleId,
    vehicleMaintenanceTicketId: to.params.vehicleMaintenanceTicketId,
  },
})

export const fleetRoutes = [
  {
    path: '/manage-fleet',
    redirect: {
      name: Routes.Vehicles,
    },
  },
  {
    path: '/manage-fleet/create-vehicle',
    redirect: {
      name: Routes.VehicleCreate,
    },
  },
  {
    path: '/manage-vehicle/:vehicleId',
    redirect: routeToVehicleRoute(Routes.VehicleManagementOverview),
  },
  {
    path: '/manage-vehicle/:vehicleId/edit',
    redirect: routeToVehicleRoute(Routes.VehicleUpdate),
  },
  {
    path: '/manage-vehicle/:vehicleId/create-maintenance-ticket',
    redirect: routeToVehicleRoute(Routes.VehicleManagementCreateMaintenanceTicket),
  },
  {
    path: '/manage-vehicle/:vehicleId/view-maintenance-ticket/:vehicleMaintenanceTicketId',
    redirect: routeToMaintenanceTicket,
  },
  {
    path: '/manage-vehicle/:vehicleId/create-vehicle-garage-assignment-log',
    redirect: routeToVehicleRoute(Routes.VehicleCreateGarageAssignmentLog),
  },
  {
    path: '/vehicle-maintenance-providers',
    name: Routes.VehicleMaintenanceProviders,
    component: () => import('@/pages/contexts/portal/vehicle-maintenance-providers/Index.vue'),
    meta: {
      pageTitle: 'Manage Vehicle Maintenance Providers',
      middleware: [
        Middleware.REQUIRES_AUTH,
        Middleware.TOGGLES_NAV_DRAWER,
      ],
      permission: AppPermissions.MANAGE_VEHICLE_MAINTENANCE,
    },
    children: [
      {
        path: 'create',
        name: Routes.VehicleMaintenanceProvidersCreate,
        component: () => import('@/pages/contexts/portal/vehicle-maintenance-providers/Create.vue'),
        meta: {
          middleware: [
            Middleware.REQUIRES_AUTH,
            Middleware.TOGGLES_NAV_DRAWER,
          ],
          permission: AppPermissions.MANAGE_VEHICLE_MAINTENANCE,
        },
      },
      {
        path: 'edit/:vehicleMaintenanceProviderId',
        name: Routes.VehicleMaintenanceProvidersEdit,
        component: () => import('@/pages/contexts/portal/vehicle-maintenance-providers/_id/Edit.vue'),
        meta: {
          middleware: [
            Middleware.REQUIRES_AUTH,
            Middleware.TOGGLES_NAV_DRAWER,
          ],
          permission: AppPermissions.MANAGE_VEHICLE_MAINTENANCE,
        },
      },
    ],
  },
  {
    path: '/vehicle-maintenance-tickets',
    name: Routes.VehicleMaintenanceTickets,
    component: () => import('@/pages/contexts/portal/vehicle-maintenance-logs/Index.vue'),
    meta: {
      pageTitle: 'Active Maintenance Tickets',
      middleware: [
        Middleware.REQUIRES_AUTH,
        Middleware.TOGGLES_NAV_DRAWER,
      ],
      permission: AppPermissions.MANAGE_VEHICLE_MAINTENANCE,
    },
    children: [
      {
        path: 'edit/:vehicleMaintenanceLogId',
        name: Routes.VehicleMaintenanceTicketEdit,
        component: () => import('@/pages/contexts/portal/vehicle-maintenance-logs/_id/Edit.vue'),
        meta: {
          middleware: [
            Middleware.REQUIRES_AUTH,
            Middleware.TOGGLES_NAV_DRAWER,
          ],
          permission: AppPermissions.MANAGE_VEHICLE_MAINTENANCE,
        },
      },
    ],
  },
]
